

function cl(msg){
                  
        
          
	console.log(msg);
}


export {cl};
